import * as React from "react";
import { useSession } from "../hooks/useSession";

const SuccessPage = () => {
  const { session } = useSession();

  React.useEffect(() => {
    session();
  }, []);

  return <div>Redirecting...</div>;
};

export default SuccessPage;
